var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BjDivider", [
        _vm._v(_vm._s(_vm.$t("billingPage.BillingInvoiceStatement"))),
      ]),
      _c(
        "el-form",
        {
          ref: "saveForm1",
          staticClass: "bj-query-form bj-query-form-for-cal-height",
          attrs: { size: "mini" },
        },
        [
          _c(
            "el-row",
            {
              staticStyle: { "margin-bottom": "10px", padding: "10px 10px" },
              attrs: { gutter: 20 },
            },
            [
              _c("el-col", { attrs: { span: (_vm.colSpan * 4) / 3 } }, [
                _c("div", [
                  _c("span", { staticStyle: { "font-weight": "bolder" } }, [
                    _vm._v(_vm._s(_vm.$t("billingPage.Current"))),
                  ]),
                  _vm._v("：$"),
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "font-weight": "bolder",
                        color: "darkslateblue",
                      },
                    },
                    [_vm._v(_vm._s(_vm.totalCurrentAmount || 0))]
                  ),
                ]),
              ]),
              _c("el-col", { attrs: { span: (_vm.colSpan * 4) / 3 } }, [
                _c("div", [
                  _c("span", { staticStyle: { "font-weight": "bolder" } }, [
                    _vm._v(_vm._s(_vm.$t("billingPage.In30Day"))),
                  ]),
                  _vm._v("：$"),
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "font-weight": "bolder",
                        color: "darkslateblue",
                      },
                    },
                    [_vm._v(_vm._s(_vm.totalIn30DaysAmount || 0))]
                  ),
                ]),
              ]),
              _c("el-col", { attrs: { span: (_vm.colSpan * 4) / 3 } }, [
                _c("div", [
                  _c("span", { staticStyle: { "font-weight": "bolder" } }, [
                    _vm._v(_vm._s(_vm.$t("billingPage.Over30Day"))),
                  ]),
                  _vm._v("：$"),
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "font-weight": "bolder",
                        color: "darkslateblue",
                      },
                    },
                    [_vm._v(_vm._s(_vm.totalOver30DaysAmount || 0))]
                  ),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "query-params": _vm.queryParams,
          "col-span": _vm.colSpan,
          "get-action": _vm.queryApi,
          radio: _vm.radio,
          "before-reset-search": _vm.beforeResetSearch,
          "tooltip-config": { showAll: false, enterable: false },
          selection: _vm.selection,
          "default-sort": _vm.defaultSort,
        },
        on: {
          handleSelectionChange: _vm.handleSelectionChange,
          showSetting: _vm.SortableTable.show,
          "sort-change": _vm.sortChange,
          "header-dragend": _vm.SortableTable.handleHeaderDragend,
          "header-contextmenu": _vm.SortableTable.handleHeaderContextmenu,
          afterFetchOriginalData: _vm.afterFetchOriginalData,
        },
        scopedSlots: _vm._u([
          {
            key: "baseForm",
            fn: function () {
              return [
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("billingPage.Client"),
                          prop: "clientCodes",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            multiple: "",
                            clearable: false,
                            "option-list": _vm.clientCodeList,
                            placeholder: _vm.$t("billingPage.Client"),
                          },
                          on: { change: _vm.handleQuery },
                          model: {
                            value: _vm.queryParams.clientCodes,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "clientCodes", $$v)
                            },
                            expression: "queryParams.clientCodes",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableOperation",
            fn: function () {
              return [
                _c(
                  "el-col",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.onCount },
                      },
                      [_vm._v(_vm._s(_vm.$t("billingPage.Counts")))]
                    ),
                    _c(
                      "el-button",
                      {
                        staticClass: "main-btn",
                        attrs: { type: "primary" },
                        on: { click: _vm.onDown },
                      },
                      [_vm._v(_vm._s(_vm.$t("downloadText")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.onExport },
                      },
                      [_vm._v(_vm._s(_vm.$t("exportText")))]
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableColumn",
            fn: function () {
              return [
                _c("vxe-column", {
                  attrs: { type: "expand", width: "40" },
                  scopedSlots: _vm._u([
                    {
                      key: "content",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _c(
                            "div",
                            { staticStyle: { padding: "10px 20px" } },
                            [
                              _c(
                                "vxe-table",
                                {
                                  attrs: {
                                    data: row.children,
                                    "empty-text": _vm.$t("table.emptyText"),
                                  },
                                },
                                [
                                  _c("vxe-column", {
                                    attrs: {
                                      type: "seq",
                                      width: "70",
                                      title: "table.countText",
                                    },
                                  }),
                                  _c("vxe-column", {
                                    attrs: {
                                      field: "id",
                                      title: _vm.$t(
                                        "billingPage.invoiceNumber"
                                      ),
                                    },
                                  }),
                                  _c("vxe-column", {
                                    attrs: {
                                      field: "totalAmount",
                                      title: _vm.$t("billingPage.invoicePrice"),
                                    },
                                  }),
                                  _c("vxe-column", {
                                    attrs: {
                                      field: "paidAmount",
                                      title: _vm.$t("billingPage.Paid"),
                                    },
                                  }),
                                  _c("vxe-column", {
                                    attrs: {
                                      field: "balance",
                                      title: _vm.$t("billingPage.Balances"),
                                    },
                                  }),
                                  _c("vxe-column", {
                                    attrs: {
                                      field: "issueDate",
                                      title: _vm.$t("billingPage.Date"),
                                    },
                                  }),
                                  _c("vxe-column", {
                                    attrs: {
                                      field: "dueDate",
                                      title: _vm.$t("billingPage.dueDate"),
                                    },
                                  }),
                                  _c("vxe-column", {
                                    attrs: {
                                      field: "Period",
                                      title: _vm.$t("billingPage.Period"),
                                      width: "400px",
                                    },
                                  }),
                                  _c("vxe-column", {
                                    attrs: {
                                      field: "week",
                                      title: _vm.$t("billingPage.Week"),
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("vxe-column", {
                  attrs: {
                    type: "seq",
                    width: "55",
                    align: "center",
                    title: "table.countText",
                  },
                }),
                _vm._l(_vm.dropCols, function (col, index) {
                  return [
                    col.prop !== "bjTableAction"
                      ? _c("vxe-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            field: col.prop,
                            sortable: "",
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || false,
                            align: "center",
                            "class-name": "item",
                            title: col.label,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    false
                                      ? void 0
                                      : col.prop == "cusId"
                                      ? [
                                          _vm._v(
                                            _vm._s(
                                              _vm.customerList.bjGet(
                                                scope.row.cusId
                                              )
                                            )
                                          ),
                                        ]
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("timeFilters")(
                                                scope.row[col.prop],
                                                scope.row[col.prop]
                                              )
                                            )
                                          ),
                                        ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                    col.prop === "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || "right",
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (props) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "delete-btn",
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onSend(props.row)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("billingPage.send"))
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                  ]
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }